import asyncActionType from "../../utils/asyncActionType";

export const FETCH_SESSIONS = asyncActionType("FETCH_SESSIONS");
export const CREATE_SESSION = asyncActionType("CREATE_SESSION");

export const CLEAN_SESSION = "CLEAN_SESSION";
export const FETCH_SESSION = asyncActionType("FETCH_SESSION");
export const UPDATE_PROD_SESSION = asyncActionType("UPDATE_PROD_SESSION");

export const ADD_INGREDIENT = asyncActionType("ADD_INGREDIENT");
export const DELETE_INGREDIENT = asyncActionType("DELETE_INGREDIENT");
export const UPDATE_INGREDIENT = asyncActionType("UPDATE_INGREDIENT");

export const ADD_PRODUCT = asyncActionType("ADD_PRODUCT");
export const UPDATE_PRODUCT = asyncActionType("UPDATE_PRODUCT");
export const DELETE_PRODUCT = asyncActionType("DELETE_PRODUCT");

export const UPDATE_LEFTOVER = asyncActionType("UPDATE_LEFTOVER");

export const FETCH_RECIPES = asyncActionType("FETCH_RECIPES");
export const CREATE_INTERMEDIATE_LABELS = asyncActionType("CREATE_INTERMEDIATE_LABELS");

export const FETCH_SESSION_OUTPUT = asyncActionType("FETCH_SESSION_OUTPUT");

export const FETCH_SESSION_DETAIL = asyncActionType("FETCH_SESSION_DETAIL");
export const UPDATE_SESSION = asyncActionType("UPDATE_SESSION");
export const FETCH_SESSION_CAN_PRODUCE = asyncActionType("FETCH_SESSION_CAN_PRODUCE");

export const FETCH_STATIONS = asyncActionType("FETCH_STATIONS");
